import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { Alert, Button, DialogActions } from '@mui/material';
import { postRequest } from 'utils/apiRequest';
import { getUrlForPath } from 'utils/functions';
import config from 'config';
import { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import CircleLoader from 'components/CircleLoader';


const StripeForm = ({ callbackUrl, onClose = () => { return ; } }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();
    setErrorMessage(null);
    setLoading(true)

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    // Trigger form validation and wallet collection
    const { error: submitError } = await elements.submit();
    if (submitError) {
      setErrorMessage(submitError.message);
      setLoading(false);
      return;
    }
    // Confirm the Subscription using the details collected by the Payment Element
    const { setupIntent, error } = await stripe.confirmSetup({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: callbackUrl,
      },
      //   redirect: 'if_required'
    });
    if (error) {
      setErrorMessage(error.message)
      // Show error to your customer (for example, payment details incomplete)
      console.log(error.message);
      setLoading(false);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };
  return ((!stripe || !elements) ? <CircleLoader /> : (
    <form onSubmit={handleSubmit}>
      {errorMessage !== null && <Alert color="error" variant="filled" sx={{mb:3}}>{errorMessage}</Alert>}
      <PaymentElement />
      <DialogActions>
        <Button variant="outlined" color="secondary" onClick={() => onClose()}>Cancel</Button>
        <LoadingButton variant="contained" color="primary" disabled={!stripe || loading} loading={loading} type="submit">Submit</LoadingButton>
      </DialogActions>
    </form>
    )
  )

}

const PaymentForm = ({ clientSecret, callbackUrl, onClose = () => { return; } }) => {
  const options = {
    // layout: 'accordion',
    // passing the client secret obtained from the server
    clientSecret: clientSecret,
  };
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_CLIENT_KEY);

  return (
    <Elements stripe={stripePromise} options={options}>
      <StripeForm callbackUrl={callbackUrl} onClose={onClose} />
    </Elements>
  );
}

export default PaymentForm;